import * as React from 'react'
import { formatOccurrenceDate } from '../../../utils/datetime'

import { OccurrenceDTO } from '../types'

type Props = {
  occurrences: OccurrenceDTO[]
  tz: string
}

// Shared OccurrenceList extracted from Journeys. Markup and classes preserved to avoid CSS regressions.
export const OccurrenceList: React.FC<Props> = ({ occurrences, tz }) => {
  if (!occurrences?.length) return <span>No dates found for current schedule</span>
  return (
    <div className="recurrence-schedule-preview-content">
      {occurrences.slice(0, 7).map((occurrence, idx) => (
        <div key={idx}>{formatOccurrenceDate(occurrence, tz)}</div>
      ))}
    </div>
  )
}
